var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "va-row" }, [
    _c(
      "div",
      { staticClass: "flex md12 xs12" },
      [
        _c("vuestic-widget", [
          _c("div", { staticClass: "va-row" }, [
            _c("div", { staticClass: "flex md4" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-sm",
                  on: { click: _vm.jumpToNewUserPage },
                },
                [
                  _c("div", { staticClass: "btn-with-icon-content" }, [
                    _c("i", { staticClass: "ion-md-person-add ion" }),
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm._f("translate")("basic.button.new")) +
                        "\n            "
                    ),
                  ]),
                ]
              ),
            ]),
          ]),
        ]),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "flex xs12 md12 w-table" },
      [
        _c("vuestic-widget", { attrs: { id: "datagridUser" } }, [
          _c(
            "div",
            { staticClass: "table-responsive" },
            [
              _c("table", { staticClass: "table table-striped" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", [
                      _vm._v(
                        _vm._s(_vm._f("translate")("tables.usering.name"))
                      ),
                    ]),
                    _c("th", [
                      _vm._v(
                        _vm._s(_vm._f("translate")("tables.usering.email"))
                      ),
                    ]),
                    _c("th", [
                      _vm._v(
                        _vm._s(_vm._f("translate")("tables.usering.createDate"))
                      ),
                    ]),
                    _c("th", [
                      _vm._v(
                        _vm._s(_vm._f("translate")("tables.usering.status"))
                      ),
                    ]),
                    _c("th", [
                      _vm._v(
                        _vm._s(_vm._f("translate")("tables.usering.actions"))
                      ),
                    ]),
                  ]),
                ]),
                _c(
                  "tbody",
                  _vm._l(_vm.userlist, function (val, index) {
                    return !_vm.isLoading
                      ? _c("tr", { key: index }, [
                          _c("td", [_vm._v(_vm._s(val.real_name))]),
                          _c("td", [_vm._v(_vm._s(val.nick_name))]),
                          _c("td", [_vm._v(_vm._s(val.create_time))]),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                val.status === 0
                                  ? _vm.$t("statusLabel.disable")
                                  : _vm.$t("statusLabel.enable")
                              )
                            ),
                          ]),
                          _c("td", { attrs: { align: "right" } }, [
                            _c("span", { staticClass: "action-color-1" }),
                            _c(
                              "span",
                              {
                                staticClass: "action-color-1",
                                staticStyle: { "margin-right": "15px" },
                                on: {
                                  click: function ($event) {
                                    return _vm.configUser(val)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("config")))]
                            ),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#f00",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteUser(index)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("delete")))]
                            ),
                          ]),
                        ])
                      : _vm._e()
                  }),
                  0
                ),
              ]),
              _vm.isLoading
                ? _c("Spinner", {
                    staticStyle: { margin: "30px auto" },
                    attrs: { size: "small" },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c("div", { staticClass: "block" }),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }